import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'MMM d, y',
  },
  display: {
    dateInput: 'dateInput',
    monthYearLabel: 'monthYear',
    dateA11yLabel: 'monthYear',
    monthYearA11yLabel: 'monthYear',
  },
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: any): string {
    if (displayFormat === 'monthYear') {
      return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    }
    return super.format(date, displayFormat);
  }
}
